import type { SVGProps } from "react";

export function GoogleDriveIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.45"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M8.25 3.75h7.5l6 10.5h-7.5l-6-10.5Z" />
      <path d="M2.25 14.25 8.25 3.75l6 10.5-3.55 6H5.8l-3.55-6Z" />
      <path d="M5.8 20.25h12.4l3.55-6h-7.5l-3.55 6H5.8Z" />
    </svg>
  );
}
